export default "__VITE_ASSET__Cwd_ncJQ__"